// @ts-ignore
import {points, bbox} from '@turf/turf';

export const isBoundingBoxLargerThanGlobe = (boundingBox: [number, number, number, number]) => {
  const xDifference = Math.abs(boundingBox[2] - boundingBox[0]);
  const yDifference = Math.abs(boundingBox[3] - boundingBox[1]);

  return xDifference > 180 || yDifference > 90;
};

const getBoundingBox = (coordinates: [number, number][]) => {
  const locations = points(coordinates);
  const boundingBox = bbox(locations) as [number, number, number, number];

  return boundingBox as [number, number, number, number];
};

export default getBoundingBox;
